import Axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";
import {
  updateTipoViajePaqueteProveedor,
  getPaqueteAll,
  newPaquete,
  updatePaquete,
  updatePaqueteEstatus,
  newPaqueteOrigen,
  newPaqueteDestinos,
  getPaqueteDestinos,
  getPaqueteById,
  deletePaqueteDestino,
  newPaqueteVuelo,
  newPaqueteExtra,
  deleteGaleriaPaquete,
  getPaqueteGaleria,
  newPaqueteGaleria,
  updateEstatusPaquete,
  newPaqueteExtraTipo
} from "../services/servicePaquete";
const urlPackage = "Package";

const dataInicial = {
  array: [],
  arrayDestinos: [],
  arrayGaleria: [],
  exito: 0,
  objeto: {},
  busqueda: "0",
};

const GET_PAQUETES_ALL = "GET_PAQUETES_ALL";
const GET_PAQUETES_CLEAR_STATE = "GET_PAQUETES_CLEAR_STATE";
const POST_PAQUETES_ALTA = "POST_PAQUETES_ALTA";
const POST_PAQUETES_ALTA_VUELO = "POST_PAQUETES_ALTA_VUELO";
const POST_PAQUETES_ALTA_DESTINOS = "POST_PAQUETES_ALTA_DESTINOS";
const POST_PAQUETES_ALTA_ORIGEN = "POST_PAQUETES_ALTA_ORIGEN";
const GET_PAQUETES_DESTINO_BY_PAQUETE = "GET_PAQUETES_DESTINO_BY_PAQUETE";
const POST_PAQUETES_ALTA_HOTEL = "POST_PAQUETES_ALTA_HOTEL";
const POST_PAQUETES_ALTA_HABITACION = "POST_PAQUETES_ALTA_HABITACION";
const POST_PAQUETES_ALTA_EXTRA = "POST_PAQUETES_ALTA_EXTRA";
const POST_PAQUETES_ALTA_SALIDA = "POST_PAQUETES_ALTA_SALIDA";
const POST_PAQUETES_ALTA_GALERIA = "POST_PAQUETES_ALTA_GALERIA";
const GET_PAQUETES_OBTENER_GALERIA = "GET_PAQUETES_OBTENER_GALERIA";
const DELETE_PAQUETES_GALERIA = "DELETE_PAQUETES_GALERIA";
const DELETE_PAQUETES_DESTINOS = "DELETE_PAQUETES_DESTINOS";
const GET_PAQUETES_BY_ID = "GET_PAQUETES_BY_ID";
const PUT_PAQUETES_ESTATUS = "PUT_PAQUETES_ESTATUS";
const PUT_PAQUETES_ACTULIZA = "PUT_PAQUETES_ACTULIZA";
const PUT_PAQUETES_ESTATUS_PAQUETE = "PUT_PAQUETES_ESTATUS_PAQUETE";
const PUT_PAQUETES_EXTRA_TIPO_PAQUETE = "PUT_PAQUETES_EXTRA_TIPO_PAQUETE"
const PUT_PAQUETES_CHANGE_INTERNACIONAL = "PUT_PAQUETES_CHANGE_INTERNACIONAL"

export default function paquetesReducer(state = dataInicial, action) {
  switch (action.type) {
    case PUT_PAQUETES_CHANGE_INTERNACIONAL:
      return { ...state, exito: action.payload.exito, array: action.payload.array}
    case PUT_PAQUETES_ESTATUS_PAQUETE:
      return { ...state, exito: action.payload.exito, array: action.payload.array }
    case PUT_PAQUETES_ACTULIZA:
      return {
        ...state,
        exito: action.payload.exito,
        array: action.payload.array,
      };
    case PUT_PAQUETES_ESTATUS:
      return {
        ...state,
        exito: action.payload.exito,
        array: action.payload.array,
      };
    case GET_PAQUETES_BY_ID:
      return { ...state, objeto: action.payload.objeto };
    case DELETE_PAQUETES_GALERIA:
      return { ...state, exito: action.payload.exito };
    case DELETE_PAQUETES_DESTINOS:
      return { ...state, exito: action.payload.exito, array: action.payload.array, arrayDestinos: action.payload.arrayDestinos };
    case GET_PAQUETES_OBTENER_GALERIA:
      return { ...state, arrayGaleria: action.payload.arrayGaleria };
    case POST_PAQUETES_ALTA_GALERIA:
      return { ...state, exito: action.payload.exito };
    case POST_PAQUETES_ALTA_SALIDA:
      return { ...state, exito: action.payload.exito };
    case POST_PAQUETES_ALTA_EXTRA:
      return { ...state, exito: action.payload.exito };
    case PUT_PAQUETES_EXTRA_TIPO_PAQUETE:
      return { ...state, exito: action.payload.exito }
    case POST_PAQUETES_ALTA_HABITACION:
      return { ...state, exito: action.payload.exito };
    case POST_PAQUETES_ALTA_HOTEL:
      return { ...state, exito: action.payload.exito };
    case GET_PAQUETES_DESTINO_BY_PAQUETE:
      return { ...state, arrayDestinos: action.payload.arrayDestinos };
    case POST_PAQUETES_ALTA_ORIGEN:
      return { ...state, exito: action.payload.exito, array: action.payload.array };
    case POST_PAQUETES_ALTA_DESTINOS:
      return { ...state, exito: action.payload.exito, array: action.payload.array, arrayDestinos: action.payload.arrayDestinos };
    case POST_PAQUETES_ALTA_VUELO:
      return { ...state, exito: action.payload.exito };
    case POST_PAQUETES_ALTA:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
      };
    case GET_PAQUETES_ALL:
      return { ...state, array: action.payload.array, busqueda: action.payload.busqueda };
    case GET_PAQUETES_CLEAR_STATE:
      return {
        ...state,
        array: action.payload.array,
        exito: action.payload.exito,
        objeto: action.payload.objeto,
      };
    default:
      return state;
  }
}

export const cambiarInternacionalPaqueteAction = ({ IdPaquete, EsInternacional}) => async (dispatch, getSate) => {
  try {
    const Busqueda = getSate().paquetes.busqueda;
    const respuesta = await updateTipoViajePaqueteProveedor({ IdPaquete, EsInternacional});
    const newPaquetes = await getPaqueteAll(Busqueda);
    dispatch({
      type: PUT_PAQUETES_CHANGE_INTERNACIONAL,
      payload: {
        array: newPaquetes,
        exito: 1,
      },
    });
    return respuesta;
  } catch (error) {
    return error;
  }
}
export const cambiarEstatusPaqueteAction = ({ ClavePaquete, idEstatusPaquete, AdministradoDooddo }) => async (dispatch, getSate) => {
  try {
    const Busqueda = getSate().paquetes.busqueda;
    const respuesta = await updateEstatusPaquete({ ClavePaquete, idEstatusPaquete, AdministradoDooddo });
    const newPaquetes = await getPaqueteAll(Busqueda);
    dispatch({
      type: PUT_PAQUETES_ESTATUS_PAQUETE,
      payload: {
        array: newPaquetes,
        exito: 1,
      },
    });
    return respuesta;
  } catch (error) {
    return error;
  }
}
export const actulizarPaqueteAction = (idPaquete, payload) => async (dispatch, getSate) => {
    try {
      const bsuqueda = getSate().paquetes.busqueda;
      const response = await updatePaquete(idPaquete, payload);
      const newPaquetes = await getPaqueteAll(bsuqueda);
      dispatch({
        type: PUT_PAQUETES_ACTULIZA,
        payload: {
          exito: 1,
          array: newPaquetes,
        },
      });
      return response;
    } catch (error) {
      return error;
    }
}
export const actulizarPaqueteEstatusAction =(idPaquete, estatus) => async (dispatch, getSate) => {
    try {
      const Busqueda = getSate().paquetes.busqueda;
      const respuesta = await updatePaqueteEstatus(idPaquete, estatus);
      const newPaquetes = await getPaqueteAll(Busqueda);
      dispatch({
        type: PUT_PAQUETES_ESTATUS,
        payload: {
          array: newPaquetes,
          exito: 1,
        },
      });
      return respuesta;
    } catch (error) {
      return error;
    }
}
export const obtenerPaquetebyIdAction = (idPaquete) => async (dispatch) => {
  try {
    const paquete = await getPaqueteById({ idPaquete });
    dispatch({
      type: GET_PAQUETES_BY_ID,
      payload: {
        objeto: paquete,
      },
    });
    return paquete;
  } catch (error) {
    return error;
  }
}
export const eliminarDestinoPaqueteAction = (idPaquete, idCiudad) => async (dispatch, getSate) => {
    try {
      const Busqueda = getSate().paquetes.busqueda;
      const respuesta = await deletePaqueteDestino({ idPaquete, idCiudad });
      const newPaquetes = await getPaqueteAll(Busqueda);
      const newDestinos = await getPaqueteDestinos(idPaquete);
      dispatch({
        type: DELETE_PAQUETES_DESTINOS,
        payload: {
          array: newPaquetes,
          arrayDestinos: newDestinos,
          exito: 1,
        },
      });
      return respuesta;
    } catch (error) {
      return error;
    }
}
export const eliminarGaleriaPaqueteAction = (clavePaquete, idPaqueteImagen) => async (dispatch) => {
    try {
      const response = await deleteGaleriaPaquete({ clavePaquete, idPaqueteImagen })
      dispatch({
        type: DELETE_PAQUETES_GALERIA,
        payload: {
          exito: 1,
        },
      });
      return response;
    } catch (error) {
      return error;
    }
}
export const altaGaleriaPaqueteAction = (payload) => async (dispatch) => {
  try {
    const response = await newPaqueteGaleria({ payload });
    dispatch({
      type: POST_PAQUETES_ALTA_GALERIA,
      payload: {
        exito: 1,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
}
export const altaSalidaPaqueteAction = (payload) => async (dispatch) => {
  try {
    const respuestaPost = await Axios.post(
      `${APIURL}/${urlPackage}/Departure`,
      payload,
      {
        headers: getCabecera(),
      }
    );
    dispatch({
      type: POST_PAQUETES_ALTA_SALIDA,
      payload: {
        exito: 1,
      },
    });
    return respuestaPost;
  } catch (error) {
    return error;
  }
}
export const actulizaPaquetetipoAction = ({ idCatExtra, idExtra, imagen, extencion }) => async (dispatch) => {
  return await newPaqueteExtraTipo({ idCatExtra, idExtra, imagen, extencion }).then(Response => {
    dispatch({
      type: PUT_PAQUETES_EXTRA_TIPO_PAQUETE,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const altaExtraPaqueteAction = (payload) => async (dispatch) => {
  try {
    const response = await newPaqueteExtra({ payload });
    dispatch({
      type: POST_PAQUETES_ALTA_EXTRA,
      payload: {
        exito: 1,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
}
export const altaHabitacionPaqueteAction = (payload) => async (dispatch) => {
  try {
    const respuestaPost = await Axios.post(
      `${APIURL}/${urlPackage}/Spot`,
      payload,
      {
        headers: getCabecera(),
      }
    );
    dispatch({
      type: POST_PAQUETES_ALTA_HABITACION,
      payload: {
        exito: 1,
      },
    });
    return respuestaPost;
  } catch (error) {
    return error;
  }
}
export const altaHotelPaqueteAction = (payload) => async (dispatch) => {
  try {
    const respuestaPost = await Axios.post(
      `${APIURL}/${urlPackage}/Hotel`,
      payload,
      {
        headers: getCabecera(),
      }
    );
    dispatch({
      type: POST_PAQUETES_ALTA_HOTEL,
      payload: {
        exito: 1,
      },
    });
    return respuestaPost;
  } catch (error) {
    return error;
  }
}
export const obtenerGaleriaByPaquete = (clavePaquete, idTipoImagen) => async (dispatch) => {
    try {
      const response = await getPaqueteGaleria({ clavePaquete, idTipoImagen })
      dispatch({
        type: GET_PAQUETES_OBTENER_GALERIA,
        payload: {
          arrayGaleria: response ? response : [],
        },
      });
      return response;
    } catch (error) {
      dispatch({
        type: GET_PAQUETES_OBTENER_GALERIA,
        payload: {
          arrayGaleria: [],
        },
      });
      return error;
    }
}
export const obtenerDestinosByPaquete = (idPaquete) => async (dispatch) => {
  try {
    const destinos = await getPaqueteDestinos(idPaquete);
    dispatch({
      type: GET_PAQUETES_DESTINO_BY_PAQUETE,
      payload: {
        arrayDestinos: destinos,
      },
    });
    return destinos;
  } catch (error) {
    return error;
  }
}
export const altaDestinosPaqueteAction = (payload) => async (dispatch, getSate) => {
  try {
    const bsuqueda = getSate().paquetes.busqueda;
    const response = await newPaqueteDestinos(payload);
    const newPaquetes = await getPaqueteAll(bsuqueda);
    const newDestinos = await getPaqueteDestinos(payload.IdPaquete)
    dispatch({
      type: POST_PAQUETES_ALTA_DESTINOS,
      payload: {
        array: newPaquetes,
        arrayDestinos: newDestinos,
        exito: 1,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
}
export const altaOrigenPaqueteAction = (payload) => async (dispatch, getSate) => {
  try {
    const bsuqueda = getSate().paquetes.busqueda;
    const response = await newPaqueteOrigen(payload);
    const newPaquetes = await getPaqueteAll(bsuqueda);
    dispatch({
      type: POST_PAQUETES_ALTA_ORIGEN,
      payload: {
        array: newPaquetes,
        exito: 1,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
}
export const altaPaqueteVueloAction = (payload) => async (dispatch) => {
  try {
    const response = await newPaqueteVuelo({ payload });
    dispatch({
      type: POST_PAQUETES_ALTA_VUELO,
      payload: {
        exito: 1,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
}
export const altaPaqueteBaseAction = (payload) => async (dispatch, getSate) => {
  try {
    const bsuqueda = getSate().paquetes.busqueda;
    const response = await newPaquete(payload);
    const paquetes = await getPaqueteAll(bsuqueda);
    dispatch({
      type: POST_PAQUETES_ALTA,
      payload: {
        array: paquetes,
        exito: 1,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
}
export const obtenerPaquetesAllAction = (Busqueda) => async (dispatch) => {
  try {
    const paquetes = await getPaqueteAll(Busqueda);
    dispatch({
      type: GET_PAQUETES_ALL,
      payload: {
        array: paquetes,
        busqueda: Busqueda,
      },
    });
    return paquetes;
  } catch (error) {
    return error;
  }
}
export const clearPaquetesState = () => async (dispatch) => {
  dispatch({
    type: GET_PAQUETES_CLEAR_STATE,
    payload: {
      array: [],
      arrayDestinos: [],
      exito: 0,
      objeto: {},
    },
  });
}